"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

var _navigation = require("./../navigation");

var _businessSelectorWrapper = _interopRequireDefault(require("./../wrappers/business-selector-wrapper"));

var BusinessSelectorNavigation = function BusinessSelectorNavigation(_ref) {
  var children = _ref.children;
  var isMobile = (0, _useResponsiveQuery.useIsMobile)();

  _react["default"].useEffect(function () {
    if (!isMobile) {
      window.navigationState.drawer.next(true);
    } else {
      window.navigationState.drawer.next(false);
    }

    window.navigationState.header.next(true);
  }, [isMobile]);

  return /*#__PURE__*/_react["default"].createElement(_businessSelectorWrapper["default"], null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.BusinessSelector, null), /*#__PURE__*/_react["default"].createElement(_navigation.PageContent, null, children)));
};

BusinessSelectorNavigation.propTypes = {
  children: _propTypes["default"].element
};
var _default = BusinessSelectorNavigation;
exports["default"] = _default;